import { moneyShort } from "@/components/marketplace/format"
import { itemAt } from "@/lib/helpers/array"
import type { SearchQuery } from "@/lib/types/search"

const PRICE_STEPS = [1000, 2000, 4000]

interface PriceTier {
  label: string
  min?: number
  max?: number
}

const LAST_STEP = itemAt(PRICE_STEPS, PRICE_STEPS.length - 1)

const PRICE_PRESETS: PriceTier[] = [
  ...PRICE_STEPS.map((step, index) => {
    const from = index > 0 ? PRICE_STEPS[index - 1] : undefined
    return {
      label: `${moneyShort(from ?? 0)}–${moneyShort(step)}`,
      min: from,
      max: step,
    }
  }),
  { label: `${moneyShort(LAST_STEP)}+`, min: LAST_STEP },
]

export const matchesPricePreset = (query: Pick<SearchQuery, "priceMin" | "priceMax">) =>
  PRICE_PRESETS.some((preset) => query.priceMin === preset.min && query.priceMax === preset.max)
